import React, { useEffect, useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { useSelector } from "react-redux";

const EditTypeModal = ({
  preview,
  previewHandler,
  selectedData,
  sucessHandler = () => {},
}) => {
  // STATES
  const [isLoading, setLoading] = useState(false);

  // CONST VALS
  const { http } = global.services;
  const [form] = Form.useForm();

  // HANDLERS
  const submitHandler = (values) => {
    setLoading(true);
    http
      .put(`communication/${selectedData.id}`, values)
      .finally(() => setLoading(false))
      .then(({ data }) => {
        toast.success("Type updated successfully");
        sucessHandler();
        previewHandler();
        form.resetFields();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  // HOOKS
  useEffect(() => {
    if (selectedData) {
      form.setFieldsValue({
        status: selectedData.title,
      });
    }
  }, [selectedData, preview]);

  return (
    <Modal
      visible={preview}
      centered
      className="add-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Update Communication Type</h2>
      <p>Enter name of type below</p>
      <Form form={form} onFinish={submitHandler}>
        <label htmlFor="name">Name</label>
        <Form.Item
          name="status"
          rules={[
            { required: true, message: "Type is required" },
            {
              max: 100,
              message: "Type should not exceed 100 characters",
            },
          ]}
        >
          <Input type="text" placeholder="Enter communication type" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit" type="submit">
            {isLoading ? <BeatLoader size={8} color="#000" /> : "Submit"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditTypeModal;
